<div class="vr">
    <div>
        <div class="hdg hdg_5">Sign In</div>
    </div>
    <form class="spdcForm js-element--signInForm" action="">
        <div class="spdcForm-row">
            <div class="spdcForm-row-item{{#if errors.username}} spdcForm-row-item_hasErrors{{/if}}" id="userName">
                <label class="spdcForm-lbl" for="username">Username</label>
                <input class="spdcForm-input js-element--signInUsername" value="{{formValues.username}}" name="username" id="username" type="text">
                <div class="spdcForm-msg spdcForm-msg_error">{{errors.username}}</div>
            </div>
        </div>
        <div class="spdcForm-row">
            <div class="spdcForm-row-item{{#if errors.password}} spdcForm-row-item_hasErrors{{/if}}" id="password">
                <label class="spdcForm-lbl" for="password">Password</label>
                <input class="spdcForm-input js-element--signInPassword" value="{{formValues.password}}" name="password" id="password" type="password">
                <div class="spdcForm-msg spdcForm-msg_error">{{errors.password}}</div>
            </div>
        </div>
        <div class="spdcForm-row">
            <div class="spdcForm-row-item">
                {{!-- Input before its label, as siblings: spdcForm.css positions the checkbox and clears it
                      only on `input[type=checkbox] + label` (see duplicateItem.hbs). Checked by default
                      (SignInFormController formValues): a customer on a shared computer unticks it. --}}
                <input class="js-element--signInRememberMe" id="rememberMe" name="rememberMe" type="checkbox"{{#if formValues.rememberMe}} checked{{/if}}>
                <label for="rememberMe">Keep me signed in</label>
            </div>
        </div>
        <div class="spdcForm-row">
            <div class="spdcForm-row-item">
                <button class="btn btn_cta btn_ctaCentered">Sign In</button>
            </div>
        </div>
    </form>
    <div class="" style="text-align: center;">
        <a class="link" href="javascript:passwordPanel.open()">Forgot Password?</a>
    </div>
</div>
